import { DistributionChannelListItem } from '../../../integrated-client/models/';

export type DistributionChannelList = Array<DistributionChannelListItem>;

export class ResultsData {

  items: DistributionChannelList
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}